import { useEffect, useState } from 'react';
import { useAsyncTask, TaskType } from '../components/AsyncTask';

type CallbackType = Array<() => void>;

const useCallbackAfterTask = (taskTypes: TaskType[], callbacks: CallbackType) => {
  const { task } = useAsyncTask();
  const [observing, setObserving] = useState<boolean>(false);
  const isRelevantTaskType = taskTypes.includes(task?.taskType);
  const isTaskDone = ['success', 'failed', 'partial_success'].includes(task?.status);

  useEffect(() => {
    if (observing && isRelevantTaskType && isTaskDone) {
      callbacks.forEach((cb: () => void) => cb());
      setObserving(false);
    } else if (isRelevantTaskType && !isTaskDone) {
      setObserving(true);
    }
  }, [task]);
};

export default useCallbackAfterTask;
